<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="1300_auto"
      :footer="false">
    <template #header>
      <span>操作日志</span>
    </template>

    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false">
        <template #filter-group>

          <app-filter-group @query="$gjNoticeQuery" :reset="false" :isBr="false">

            <gj-country-server-select
                v-model="filter.countryIdList"
                :width="['140px', '170px']"
            ></gj-country-server-select>


            <div class="flex align-center size12" style="margin-left: 14px!important;">数据月份:</div>
            <gj-date-picker
                v-model="filter.months"
                type="monthrange"
                startPlaceholder="开始月份"
                endPlaceholder="结束月份"
                :shortcut="null"
                tooltip="数据月份"
            ></gj-date-picker>

            <gj-select-date-picker
                type="daterange"
                v-model="filter.date"
                :options="[
                {id: '0', text: '日期范围'},
                {id: '1', text: '操作时间'},
              ]"
            ></gj-select-date-picker>

            <gj-input
                v-model="filter.keyword"
                placeholder="输入报表名称、操作用户"
                width="200px"
            ></gj-input>

          </app-filter-group>

        </template>

        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :data="tableData"
              :columns="columns"
              :loading="loading"
              :adapt-height="false"
              :height="500"
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery"
          >
            <template v-slot:attachmentSizeText="{row}">
              {{row.attachmentSizeText}}
              <template v-if="row.attachmentId==='0'||isMeaningless(row.attachmentId)">-</template>
              <gj-button v-else type="text" :loading="row.downLoad" @click="logDownLoad(row)">下载</gj-button>
            </template>

          </gj-table>
        </template>

      </app-base-main>

    </template>
  </gj-modal>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin, modalMixIn} from "@/minxins";
import {convertToDate, convertToMonth} from "@/utils/date.util";
import {dateRangeLog, dateRangeLogDownload} from "@/api/statistics";
import {exportFile} from "@/api/common";
import {mapGetters} from "vuex";
import {isMeaningless} from "@/utils/common";

export default {
  name: "log-modal",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, modalMixIn],
  props: {
    id: null
  },
  computed: {
    ...mapGetters(['marketOption']),
  },
  data() {
    return {
      loading: false, // 加载
      tableData: [], // 表格数据
      filter: {
        countryIdList: {},// 国家、店铺
        months: [],// 数据月份
        keyword: null,// 查询关键字：报表名称或者操作用户
        date: {
          key: '0',//查询的日期类型：0，日期范围；1，记录日期；2，更新日期
          value: []
        }
      },
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '140px', options: () => this.marketOption},
        {id: 'recordMonth', header: '数据月份', field: 'recordMonth', width: '90px'},
        {id: 'dateRange', header: '日期范围', field: 'dateRange', width: '220px'},
        {id: 'operationTypeName', header: '操作类型', field: 'operationTypeName', width: '120px'},
        {id: 'operationTcontent', header: '操作内容', field: 'operationTcontent', minWidth: '220px', overflowLine: 1},
        {id: 'attachmentSizeText', header: '文件下载', field: 'slot:attachmentSizeText', width: '160px'},
        {id: 'createUser', header: '操作用户 ', field: 'createUser', width: '120px'},
        {id: 'createTime', header: '操作时间', field: 'createTime', width: '160px', sortable: true},
      ],
    }
  },
  methods: {
    isMeaningless,
    async $gjQuery() {
      this.loading = true
      let params = {
        model: {
          ...this.filter,
          countryIdList: this.filter.countryIdList.countryIds || [],//国家编码集合
          marketIdList: this.filter.countryIdList.marketIds || [],//店铺id集合
          dateType: this.filter.date.key,//查询的日期类型：1，记录日期；2，更新日期
          reportMainLogId: this.id,
          startDate: this.filter.date.value?convertToDate(this.filter.date.value[0]):'',//开始时间
          endDate: this.filter.date.value?convertToDate(this.filter.date.value[1]):'',//结束时间
          startMonth: this.filter.months?convertToMonth(this.filter.months[0]):'',
          endMonth: this.filter.months?convertToMonth(this.filter.months[1]):''
        },
        ...this.queryPagination,
        ...this.querySort
      };
      try {
        let data = await dateRangeLog(params) || {}
        this.pagination = this.getPagination(data);
        this.tableData = data.records.map(r => {
          return {
            ...r,
            downLoad:false
          }
        })
      } finally {
        this.loading = false
      }
    },
    logDownLoad(row){
      row.downLoad = true;
      // dateRangeLogDownload({idList:[row.id]}).then(data=>{
        exportFile(`/file/attachment/download`, [row.attachmentId]).then(res=>{
          this.$gjResetPage()
        }).complete(() => {row.downLoad = false;});
      // })
    }
  }
}
</script>

<style scoped>

</style>